import { render } from "./IconSearch.vue?vue&type=template&id=44707092"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconSearch.vue"]])

export default __exports__